import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";

import image1 from "../../../images/gear/gera-oil/8614/8614_1front.webp";
import image2 from "../../../images/gear/gera-oil/8614/8614_1back.webp";



const images = [
  { src: image1, alt: "Front" },
  { src: image2, alt: "Back" },

];

const packageSlides = [
  { images: [image1, image2] },
 

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/80";


const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF8614_-_FANFARO 8614 AZF 8_(SK).pdf" }
];





export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
   <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://www.amazon.in/FANFARO-Fully-Synthetic-Automatic-Transmission/dp/B07N7L3DP8/ref=sr_1_1?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>
FANFARO AZF 8 8614</h2>

        <p>
         A special all-season synthetic transmission fluid (ATF) for modern 8-speed automatic gearboxes of all types and 6-speed automatic gearboxes of the ZF Group. It ensures a flawless operation of an automatic gearbox, guarantees minimal wear, a lasting service life of transmissions and fuel economy even under extreme loads. It was developed taking into account special requirements set by the VW Group.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
          <li>The highest-quality low-viscosity synthetic base with a consistent high viscosity index in combination with a multifunctional additive package preserves all its properties in a wide range of temperatures: it ensures good lubricating properties at low (-45 °C) temperatures in winter and ensures a stable oil film under extreme loads and high temperatures in summer.</li>
          <li>A high-tech combination of additives provides good anti-friction properties for gearing and excellent frictional properties for friction elements, which ensures significant fuel economy, exceptionally soft and smooth gearshifts without jerking and a significant increase in the service life of all transmission elements.</li>
          <li>It has an increased thermal-oxidative and chemical stability and resistance to the high-temperature thermal degradation throughout the entire service life. It allows reducing lacquering, formation of sludge, soot and other carbon deposits, increasing the time between oil changes and ensuring the durability of transmission components thus reducing the equipment maintenance costs.</li>
          <li> It has unsurpassed thermal oxidative and chemical stability and resistance to high-temperature thermal degradation over the entire life cycle. This allows to minimize the formation of sludge, varnish, soot and other carbon deposits, significantly increase the oil change interval and ensure the durability of transmission parts, which reduces the cost of maintenance.</li>
          <li>  The special additive package enhances the productivity and reliability of hydraulic converters and hydraulic clutches, gear wheels, hydraulic servo drives.</li>
          <li> Due to the addition of special inhibitors, it effectively protects metal parts from ferrous and non-ferrous alloys from corrosion when both in and not in operation.</li>
          <li>It effectively resists aeration, the foam formation and cavitation, has excellent cooling properties; It has low loss by evaporation.</li>
          <li> It ensures a compatibility with all sealing materials, prevents them from swelling, hardening and shrinking that allows reducing the costs for spare parts and prevents leakages.</li>
          <li>It reduces noise.</li>
        </ul> <br />

        <p>
         It is recommended for new-generation 8- and 6-speed transmissions of the ZF Group for Volkswagen, Audi, Seat, Skoda passenger cars and commercial vehicles in which the compliance with the VW G 060 162 requirements and the above-mentioned specifications of European manufacturers, as well as Aston Martin, Ford, Hyundai, Jaguar, Kia, Maserati, Porsche with ZF Group automatic gearboxes is required. <br />

        Colour: green. <br />
       Comply with the manufacturer’s instructions provided in the user’s manual!
        </p>


        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>JASO -M315, Class 1-A-LV</li>
              
            </ul>
          </div>


          {/* <div>
            <b>Recommendation</b>
          
          </div> */}

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF8614-1)
                </span>
              </li>

              {/* <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6201-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6201-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6201-IBC)
                </span>
              </li> */}

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href="https://www.fanfaro.de/create-pdf/80"
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>FANFARO M-4T Plus</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
   </>
  );
}